const value = {
    searching: 'Поиск менеджеров...',
    noResults: 'Менеджеры не найдены',
    manager: 'Менеджер ИБ',
    summarySubtitle: 'Любая дополнительная информация по проекту.',
  };

export default value;
